import React, { useEffect } from 'react';

import SectionCompleteDetailed from './section-complete-detailed';
import SectionCompleteGeneric from './section-complete-generic';
import { useStudentInfo } from '../../../hooks/lesson-player.context';
import { useActivityContext } from '../../../hooks/use-activity.context';

export function SectionComplete() {
  const { lessonInfo, completeCurrentActivity } = useActivityContext();
  const studentInfo = useStudentInfo();

  useEffect(() => {
    completeCurrentActivity();
  }, []);

  if (lessonInfo && studentInfo) {
    return <SectionCompleteDetailed />;
  }

  return <SectionCompleteGeneric />;
}
